import React, { useEffect, useState } from "react";
import { CheckboxSize } from "ui-v2/types/checkbox";
import { ActionType } from "ui-v2/types/radio";

export interface CheckHOCProps {
  isChecked?: boolean;
  onChange?: (v: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  id?: string;
  label?: string;
  description?: string;
  containerStyle?: React.CSSProperties;
  showIcon?: boolean;
  action?: keyof typeof ActionType;
  size?: keyof typeof CheckboxSize;
}

const withCheckHOC = (OriginalComponent: React.FunctionComponent<any>) => {
  const NewComponent = (props: CheckHOCProps) => {
    const { isChecked, onChange, ...propsToFwd } = props;
    const [isCbChecked, setIsCbCheck] = useState(isChecked ?? false);
    useEffect(() => {
      if (typeof isChecked === "boolean") {
        setIsCbCheck(isChecked);
      }
    }, [isChecked]);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange instanceof Function) {
        onChange(e);
      } else setIsCbCheck(e.target.checked);
    };

    return (
      <OriginalComponent
        isChecked={isCbChecked}
        onChange={handleChange}
        {...propsToFwd}
      />
    );
  };
  return NewComponent;
};

export default withCheckHOC;
